<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>Relatório - Faturamento de Serviços</span>
                </h4>
                <filtros-faturamento-servicos 
                v-if="responsaveis && unidades && fornecedores"
                :unidades="unidades"
                :fornecedores="fornecedores"
                :responsaveis="responsaveis"
                @filtroAtualizado="filtro = $event"/>
            </b-card-body>
            <b-card-footer>
                 <app-btn-voltar></app-btn-voltar>
                <b-button
                    variant="primary"
                    @click.stop="emitirRelatorio"
                    class="ml-2"
                >
                    <span>
                        <i class="fa fa-file-o mr-2"></i> Emitir Relatório
                    </span>
                </b-button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import FiltrosFaturamentoServicos from './FiltrosFaturamentoServicos.vue'
import RelatoriosServicos from './RelatoriosServicos'

export default {
    components: {
        FiltrosFaturamentoServicos
    },
    data() {
        return {
            responsaveis: null,
            unidades: null,
            fornecedores: null,
            filtro: {
                numeroContrato: null,
                responsavel: null,
                unidade: null,
                fornecedor: null,}
        }
    },
    methods: {
        obterFiltrosOpcoes() {
            this.$store.dispatch('addRequest')
            RelatoriosServicos.obterFiltrosOpcoes('ruf').then((response) => {
                if (response) {
                    if (response.success) {
                        this.responsaveis = response.data.Funcionarios
                        this.responsaveis.unshift({
                            codFuncionario: null,
                            nome: 'TODOS'
                        })
                        this.unidades = response.data.Unidades
                        this.unidades.unshift({
                            codUnidade: null,
                            nome: 'TODAS'
                        })
                        this.fornecedores = response.data.Fornecedores
                        this.fornecedores.unshift({
                            codFornecedor: null,
                            nome: 'TODOS'
                        })
                    } else {
                        this.$toast.error(
                            'Erro ao obter opções do filtro!',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
        emitirRelatorio() {
            this.$store.dispatch('addRequest')
            RelatoriosServicos.emitirRelatorio('faturamentodeservicos', this.filtro).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Falha ao obter relatório',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                         this.$download(response, `Relatorio_Faturamento_Servicos.xlsx`)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },
    mounted() {
        this.obterFiltrosOpcoes()
    },
     watch: {
        filtro() {}
    }
}
</script>